import { ActionRow } from './ActionRow';
import { MetricHeroes } from './MetricHeroes';
import { StatusList } from './StatusList';
import * as DataProviderTypes from '../../types/data-providers';
import * as PXBcore from '@brightlayer-ui/react-components/core';
import * as Styles from './styles';
import * as Types from './types';
import alarmBackgroundImage from '../../assets/images/alarm-background.png';
import normalBackgroundImage from '../../assets/images/normal-background.png';
import React from 'react';
import { AppRoute } from '../../routes';
import { ChannelDatum } from '../../types';
import { pushAppRoute } from '../../data/domain/route-manager';
import { useHistory } from 'react-router-dom';

type Props = {
    id: string;
    title: string;
    subtitle?: string | undefined;
    headerInfo?: string | undefined;
    loadingComponent: React.ElementType;
    navigationLabel: string;
    navigationTargetAppRoute: AppRoute;
    hasAlarm?: boolean | undefined;
    dataState: DataProviderTypes.DataState;
    channelData?: ChannelDatum[];
    statusItems?: Types.StatusItem[];
    statusDataState?: DataProviderTypes.DataState;
};

function getBackgroundColor(args: {
    dataState: DataProviderTypes.DataState;
    hasAlarm: boolean | undefined;
}): string | undefined {
    return args.dataState === DataProviderTypes.DataState.Loaded
        ? args.hasAlarm
            ? alarmBackgroundImage
            : normalBackgroundImage
        : undefined;
}

function getHeaderColor(args: {
    dataState: DataProviderTypes.DataState;
    hasAlarm: boolean | undefined;
}): string | undefined {
    return args.dataState === DataProviderTypes.DataState.Loading ||
        args.dataState === DataProviderTypes.DataState.Error
        ? Styles.colors.loading
        : args.hasAlarm
        ? Styles.colors.alarm
        : Styles.colors.normal;
}

const OverviewCard: React.FC<Props> = (props) => {
    const history = useHistory();
    const classes = Styles.useStyles();
    const headerColor = getHeaderColor({ dataState: props.dataState, hasAlarm: props.hasAlarm });
    const headerBackgroundImage = getBackgroundColor({ dataState: props.dataState, hasAlarm: props.hasAlarm });

    const navigation = (): void => {
        pushAppRoute(history, props.navigationTargetAppRoute);
    };
    return (
        <PXBcore.ScoreCard
            onClick={(): void => {
                navigation();
            }}
            style={{
                width: '360px',
                margin: '5px',
                cursor: 'pointer',
            }}
            headerTitle={props.title}
            headerSubtitle={<div data-testid="overview-card-alarm-count">{props.subtitle}</div>}
            headerInfo={props.headerInfo}
            headerColor={headerColor}
            headerBackgroundImage={headerBackgroundImage}
            actionLimit={1}
            actionRow={<ActionRow label={props.navigationLabel} appRoute={props.navigationTargetAppRoute} />}
            badge={
                props.dataState === DataProviderTypes.DataState.Loaded && props.channelData ? (
                    <MetricHeroes channelData={props.channelData} />
                ) : (
                    <></>
                )
            }
        >
            <div className={classes.content} data-testid="overview-card-content">
                {props.statusDataState === DataProviderTypes.DataState.Loading && <props.loadingComponent />}
                {props.statusDataState === DataProviderTypes.DataState.Loaded && (
                    <StatusList items={props.statusItems || []} />
                )}
            </div>
        </PXBcore.ScoreCard>
    );
};

export { OverviewCard };
